module.exports = __webpack_public_path__ + "img/symbol_0.3bc37792.png";